import React, { FC } from "react";
import classNames from "classnames";
import { GatsbyImage, getImage, ImageDataLike } from "gatsby-plugin-image";
import { Button } from "@app/components/common";

type Props = {
  imageData: ImageDataLike;
  imageAlt: string;
  title: string;
  text: string;
  buttonLabel: string;
  onButtonClick: () => void;
};

export const Card: FC<Props> = ({
  imageData,
  imageAlt,
  title,
  text,
  buttonLabel,
  onButtonClick,
}) => {
  return (
    <div className="flex flex-col rounded-3xl bg-[#141517]">
      <div className="aspect-video w-full">
        <GatsbyImage
          image={getImage(imageData)}
          alt={imageAlt}
          className="aspect-video w-full rounded-t-3xl"
        />
      </div>

      <div
        className={classNames(
          "grow-1 flex h-full flex-col justify-between gap-y-5 rounded-b-3xl px-5 py-6",
          "2xl:py-10 xl:px-7.5",
        )}
      >
        <div className={classNames("space-y-2.5", "xxl:space-y-5")}>
          <h4
            className={classNames(
              "text-medium text-primary-content",
              "xxl:text-large",
            )}
          >
            {title}
          </h4>
          <p className={classNames("text-regular text-base-400")}>{text}</p>
        </div>
        <Button label={buttonLabel} onClick={onButtonClick} isFullWidth />
      </div>
    </div>
  );
};
